import { ACTION_GET_ORGANISATION_NAME, ActionGetOrganisationName } from "./actions/getOrganisationName";

interface UserDetailsState {
    readonly organisationName: string;
}

const initialState: UserDetailsState = {
    organisationName: ""
}

type UserDetailsActions = ActionGetOrganisationName

const userDetailsReducer = (state = initialState,  action: UserDetailsActions): UserDetailsState => {
    switch(action.type) {
        case "ACTION_GET_ORGANISATION_NAME":
            return {
                ...state,
                organisationName: action.payload
            }
        default:
            return state;
    }
}

export default userDetailsReducer;

